import track from '../../../shared/util/utilities/mixpanel';

export default function workflowsTracker(action: string, trackingData?: object) {
    track('workflows', action, trackingData);
}
